import React from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import { Col, Grid, Row } from 'react-bootstrap';


const propTypes = exact({
  title: PropTypes.string.isRequired,
  render: PropTypes.func.isRequired,
  showHeader: PropTypes.bool,
});


const PageLayout = (props) => {
  const { title, render, showHeader } = props;
  return (
    <Grid fluid>
      {showHeader && (
        <React.Fragment>
          <Row>
            <Col xs={12}>
              <h2>{title}</h2>
            </Col>
          </Row>
          <Row>
            <Col xs={12}>
              <hr />
            </Col>
          </Row>
        </React.Fragment>
      )}
      <Row>
        <Col xs={12}>
          {render()}
        </Col>
      </Row>
    </Grid>
  );
};


PageLayout.propTypes = propTypes;
PageLayout.defaultProps = {
  showHeader: true,
};


export default PageLayout;
